// findloop web API client — mirrors the mobile app's business logic.
const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// Resolve a user's avatar image src: object-storage URL (preferred) or legacy base64.
export function avatarUrlOf(obj) {
  if (!obj) return null;
  if (obj.avatar_url) return `${BASE}${obj.avatar_url}`;
  return obj.avatar_base64 || null;
}

const TOKEN_KEY = "findo_token_v1";
const B2C_TOKEN_KEY = "findo_b2c_token_v1";

// Auth tokens live in sessionStorage so each browser TAB keeps its own session.
// This prevents a login in one tab from hijacking another tab's account on refresh.
// "Remember me" additionally persists the token in localStorage; a fresh tab seeds
// its (empty) session from that persistent copy — while a tab that already has its
// own session is never overwritten, so multi-account tab isolation is preserved.
function seedFromPersistent(key) {
  try {
    const persist = localStorage.getItem(key);
    if (persist && !sessionStorage.getItem(key)) sessionStorage.setItem(key, persist);
  } catch { /* ignore */ }
}
seedFromPersistent(TOKEN_KEY);
seedFromPersistent(B2C_TOKEN_KEY);

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t, remember = false) => {
  sessionStorage.setItem(TOKEN_KEY, t);
  try { remember ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
};
export const clearToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ }
};

export const getB2CToken = () => sessionStorage.getItem(B2C_TOKEN_KEY);
export const setB2CToken = (t, remember = false) => {
  sessionStorage.setItem(B2C_TOKEN_KEY, t);
  try { remember ? localStorage.setItem(B2C_TOKEN_KEY, t) : localStorage.removeItem(B2C_TOKEN_KEY); } catch { /* ignore */ }
};
export const clearB2CToken = () => {
  sessionStorage.removeItem(B2C_TOKEN_KEY);
  try { localStorage.removeItem(B2C_TOKEN_KEY); } catch { /* ignore */ }
};

export async function uploadFile(path, file, { b2c = false } = {}) {
  const headers = {};
  const t = b2c ? getB2CToken() : getToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  const fd = new FormData();
  fd.append("file", file);
  const res = await fetch(`${API}${path}`, { method: "POST", headers, body: fd });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || "Échec du téléversement");
  return data;
}

export async function api(path, opts = {}) {
  const method = opts.method || "GET";
  const headers = { "Content-Type": "application/json", "X-Findo-Lang": document.documentElement.lang || "fr" };
  if (opts.auth !== false) {
    const t = opts.b2c ? getB2CToken() : getToken();
    if (t) headers.Authorization = `Bearer ${t}`;
  }
  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  });
  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    const raw = data && (data.detail || data.message);
    let msg;
    if (typeof raw === "string") msg = raw;
    else if (raw && typeof raw === "object" && typeof raw.message === "string") msg = raw.message;
    else if (Array.isArray(raw) && raw[0] && typeof raw[0].msg === "string")
      msg = raw.map((e) => e.msg).join(" · ");
    else msg = `Erreur ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export function qrUrl(partnerId) {
  return `${API}/partners/${partnerId}/qr.png`;
}
